import { render } from "./gsrsu04010201.vue?vue&type=template&id=65d0c12c&scoped=true"
import script from "./gsrsu04010201.vue?vue&type=script&lang=js"
export * from "./gsrsu04010201.vue?vue&type=script&lang=js"

import "./gsrsu04010201.vue?vue&type=style&index=0&id=65d0c12c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d0c12c"]])

export default __exports__